import { render } from "./DrawObjects.vue?vue&type=template&id=259f3daa&scoped=true"
import script from "./DrawObjects.vue?vue&type=script&lang=js"
export * from "./DrawObjects.vue?vue&type=script&lang=js"

import "./DrawObjects.vue?vue&type=style&index=0&id=259f3daa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-259f3daa"]])

export default __exports__